<template>
    <section class="content-prize container" id="prizes">
      <div class="content-prize-title">
        <h1>{{ prizes.title }}</h1>
        <div class="content-prize-line">
          <span></span>
        </div>
      </div>
      <div class="content-prize-elements">
        <div class="content-prize-elements-text">

            <p v-html="prizes.description"></p>
            <div class="btn btn-seeall">
                <router-link tag="a" to="/prizes">
                    ver todos prémios
                </router-link>
            </div>
        </div>
        <div class="content-prize-elements-img">
          <img :src="prizes.image"
           alt="prize">
        </div>
      </div>
    </section>
  </template>
<script>
  export default {
    name: 'Prize',
    components: {
    },
    props: {
      prizes: {
        type: Object,
        default: () => {}
      },
    },
  }
</script>
  
  <style lang="scss">
  .content-prize {
    padding-top: 120px;
    width: 100%;
    height: 100%;
    @media screen and (max-width: 992px) {
      max-width: 600px;
      padding-left: 25px;
      padding-right: 25px;
    }
    &-title {
        text-align: left;
        display: flex;
        flex-direction: row;
        align-items: flex-end;
        width: 100%;
        white-space: nowrap;
        @media screen and (max-width: 992px) {
          flex-direction: column;
          white-space: normal;
          align-items: flex-start;
        }
    }
    &-line {
        width: 100%;
        height: 2px;
        background-color:#F5891F;
        margin-bottom: 20px;
        margin-left: 20px;
        @media screen and (max-width: 992px) {
          margin-left: 0;
        }
        span {
            width: 100%;
            height: 2px;
            background-color: #F5891F;
        }
    }
    &-elements{
        margin-top: 62px;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        @media screen and (max-width: 992px) {
          flex-direction: column-reverse;
          align-items: center;
          margin-top: 30px;
        }
        &-text{
            max-width: 600px;
            justify-content: flex-start;
            display: flex;
            flex-direction: column;
            line-height: 44px;
            text-align: start;
            .btn-seeall{
              padding: 0;
              width: 100%;
              display: flex;
              align-items: flex-start;
              justify-content: flex-start;
              @media screen and (max-width: 992px) {
                justify-content: center;
              }
              a{
                  width: 216px;
                  height: 56px;
                  background: rgb(254,206,9);
                  background: linear-gradient(90deg, rgba(254,206,9,1) 0%, rgba(245,137,31,1) 100%);
                  border-radius: 10px;
                  color: black;
                  font-size: 18px;
                  font-family: 'Font Bold';
                  text-transform: uppercase;
                  display: flex;
                  align-items: center;
                  justify-content: center;
              }
            }
        }
        &-img{
            width: 100%;
            max-width: 710px;
            height: auto;
            @media screen and (max-width: 992px) {
              max-width: 100%;
            }
            img{
                width: 100%;
                height: auto;
            }
        }
    }
  }
  </style>
  